import saSdk from '../../../services/service-awards-sdk';
import { Intent } from '@blueprintjs/core';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    program: {},
    programLoading: false,
    programLoadingError: null,
    recipients: [],
    recipientsLoading: false,
    recipientsLoadingError: null,
    busyGeneratingGiftCode: false,
    busySendingRecipientEmail: false,
    busySendingReminderEmail: false,
    busySendingExpirationEmail: false,
    toast: null
};

const errorToast = {
    message: '',
    intent: Intent.DANGER,
    icon: 'warning-sign',
    timeout: 0
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'recipientList/setState';

/*******************************************************************************
 * Reducer
 */
export default function recipientListReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}


function loadProgram( programId ) {
    return ( dispatch ) => {
        if ( programId ) {
            dispatch( setState( {
                programLoading: true,
                programLoadingError: null
            } ) );

            saSdk.getProgram( programId )
                .then( ( program ) => {
                    dispatch( setState( {
                        program,
                        programLoading: false
                    } ) );
                } )
                .catch( ( err ) => {
                    dispatch( setState( {
                        programLoading: false,
                        programLoadingError: err
                    } ) );
                } );
        }
    };
}

function unloadProgram( programId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            program: {},
            programLoading: false,
            programLoadingErrors: null
        } ) );
    };
}

function searchRecipients( filters, properties ) {
    return ( dispatch ) => {
        dispatch( setState( {
            recipientsLoading: true,
            recipientsLoadingError: null
        } ) );

        saSdk.searchRecipients( filters, properties )
            .then( ( { celebrations, errors, count } ) => {
                const state = {
                    recipients: celebrations,
                    recipientCount: count,
                    recipientsLoading: false
                };
                if ( errors.length > 0 ) {
                    const errorMessage = errors[ 0 ].message;
                    state.recipientsLoadingError = errorMessage;
                    state.toast = {
                        ...errorToast,
                        message: errorMessage
                    };
                }
                dispatch( setState( state ) );
            } )
            .catch( ( err ) => {
                let errorMessage = 'An error occurred while searching';
                if ( err && err.errors && err.errors.length > 0 ) {
                    errorMessage = err.errors[ 0 ].message;
                }
                dispatch( setState( {
                    recipientsLoading: false,
                    recipientsLoadingError: errorMessage,
                    toast: {
                        ...errorToast,
                        message: errorMessage
                    }
                } ) );
            } );
    };
}

function unloadRecipients( programId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            recipients: [],
            recipientsLoading: false,
            recipientsLoadingError: null
        } ) );
    };
}

function clearToast() {
    return ( dispatch ) => {
        dispatch( setState( { toast: null } ) );
    };
}

export const actions = {
    loadProgram,
    unloadProgram,
    searchRecipients,
    unloadRecipients,
    clearToast
};
